import { Button } from 'antd';
import { FC, useState } from 'react';
import cn from 'classnames';

import { useAppDispatch, useAppSelector } from 'hooks';
import { deleteCounteroffer } from 'features/secondaryMarket/secondaryMarketSlice';
import { ICounterofferButton } from 'models';
import { selectIsAdmin } from 'selectors';

import { ConfirmationModal } from 'componets/ui';

import { SecondaryMarketCounterofferCancelModal } from 'pages/Account/Invest/SecondaryMarket/SecondaryMarketOffers/SecondaryMarketCounteroffer';

export const CounterofferButton: FC<ICounterofferButton> = ({
	type,
	text,
	callback,
	id,
	isCancel,
	confirmTitle,
	confirmText,
}) => {
	const isAdmin = useAppSelector(selectIsAdmin);
	const [isOpen, setIsOpen] = useState(false);
	const dispatch = useAppDispatch();

	const [isSubmitting, setIsSubmitting] = useState(false);

	const needsConfirmation = isCancel || (!!confirmTitle && !!confirmText);

	const onClick = () => {
		setIsSubmitting(true);

		dispatch(callback(id))
			.unwrap()
			.then(() => {
				if (!isCancel) {
					dispatch(deleteCounteroffer(id));
				}
			})
			.catch((e) => {
				if (!isCancel) {
					const isOfferCanceled =
						e.message === "Can't reject offer in CANCELED status" ||
						e.message === "Can't accept offer in CANCELED status";

					if (isOfferCanceled) {
						dispatch(deleteCounteroffer(id));
					}
				}
			})
			.finally(() => {
				setIsSubmitting(false);
				setIsOpen(false);
			});
	};

	return (
		<>
			<Button
				type={type}
				className={cn({ 'ant-btn-grey': type === 'primary' && isAdmin })}
				onClick={needsConfirmation ? () => setIsOpen(true) : onClick}
				loading={isSubmitting}
			>
				{text}
			</Button>
			{isCancel && (
				<SecondaryMarketCounterofferCancelModal
					id={id}
					onClose={() => setIsOpen(false)}
					isOpen={isOpen}
				/>
			)}
			{!isCancel && confirmTitle && confirmText && (
				<ConfirmationModal
					loading={isSubmitting}
					isOpen={isOpen}
					onClose={() => setIsOpen(false)}
					onAgree={onClick}
					title={confirmTitle}
					text={confirmText}
				/>
			)}
		</>
	);
};
